import React from 'react';
import styles from './backdrop.module.scss';
import Fade from '@smart-tv/components/fade/fade';
import clscx from 'clsx';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean;
  disablePortal?: boolean;
}

export const Backdrop: React.FC<Props> = (props: Props) => {
  const { children, open, disablePortal, className, ...rest } = props;

  return (
    <Fade in={open} unmountOnExit>
      <div aria-hidden={true} {...rest} className={clscx(styles['backdrop'], { [styles['backdrop--disable-portal']]: disablePortal }, className)}>
        {children}
      </div>
    </Fade>
  );
};

export default Backdrop;
